module.exports = __webpack_public_path__ + "img/bolsa-auxilio.b786704e.svg";